module.exports = __webpack_public_path__ + "static/media/landscape.8b61dfdc.svg";